import { render, staticRenderFns } from "./AccessExpirationDateAlert.vue?vue&type=template&id=1f55fad6&"
import script from "./AccessExpirationDateAlert.vue?vue&type=script&lang=js&"
export * from "./AccessExpirationDateAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports